import React from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentCancelledPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-red-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full">
        <div className="text-center">
          {/* Icon */}
          <div className="mb-6">
            <div className="w-20 h-20 mx-auto bg-orange-100 rounded-full flex items-center justify-center">
              <svg className="w-12 h-12 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
          </div>

          {/* Title */}
          <h1 className="text-2xl font-bold text-gray-900 mb-4">
            Payment Cancelled
          </h1>

          {/* Message */}
          <p className="text-gray-600 mb-6">
            Your payment has been cancelled. No charges have been made to your account.
          </p>

          {/* Info Box */}
          <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-6 text-left">
            <h3 className="font-semibold text-blue-900 mb-2">Why upgrade to Pro?</h3>
            <ul className="space-y-2 text-sm text-blue-800">
              <li className="flex items-center">
                <span className="text-blue-500 mr-2">✓</span>
                Unlimited contacts and storage
              </li>
              <li className="flex items-center">
                <span className="text-blue-500 mr-2">✓</span>
                Advanced features and integrations
              </li>
              <li className="flex items-center">
                <span className="text-blue-500 mr-2">✓</span>
                Priority customer support
              </li>
              <li className="flex items-center">
                <span className="text-blue-500 mr-2">✓</span>
                30-day money-back guarantee
              </li>
            </ul>
          </div>

          {/* Action Buttons */}
          <div className="space-y-3">
            <button
              onClick={() => navigate('/payment', { replace: true })}
              className="w-full bg-gradient-to-r from-blue-500 to-indigo-600 text-white py-3 rounded-xl font-medium hover:from-blue-600 hover:to-indigo-700 transition-all duration-200 transform hover:scale-105"
            >
              Try Again - Upgrade to Pro
            </button>
            <button
              onClick={() => navigate('/', { replace: true })}
              className="w-full bg-gray-200 text-gray-700 py-3 rounded-xl font-medium hover:bg-gray-300 transition-all duration-200"
            >
              Return to Dashboard
            </button>
          </div>

          {/* Support Link */}
          <p className="text-sm text-gray-500 mt-6">
            Need help? Contact our{' '}
            <button
              onClick={() => navigate('/settings/support')}
              className="text-blue-600 hover:text-blue-800 underline"
            >
              support team
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelledPage;
